import { render, staticRenderFns } from "./Transferencias.vue?vue&type=template&id=66c21d66&scoped=true&"
import script from "./Transferencias.vue?vue&type=script&lang=js&"
export * from "./Transferencias.vue?vue&type=script&lang=js&"
import style0 from "./Transferencias.vue?vue&type=style&index=0&id=66c21d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c21d66",
  null
  
)

export default component.exports